import {createApp} from 'vue';
import {createPinia} from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';
import router from './router';
import './assets/main.css';
import mvcVueIntegration from "@/MvcVueIntegration.ts";
import VueCookies from 'vue-cookies';

const components = mvcVueIntegration.getComponents();

document.querySelectorAll('[data-vue-component]').forEach(element => {
	const componentName = (element as HTMLElement).dataset.vueComponent;

	if (!componentName) {
		console.error('No component name specified for element:', element);
		return;
	}

	const component = components[componentName];

	if (component) {
		const props = JSON.parse((element as HTMLElement).dataset.props || '{}');
		const app = createApp(component, props);
		const pinia = createPinia()
		pinia.use(piniaPluginPersistedstate)
		app.use(pinia);
		app.use(router);
		app.use(VueCookies);
		app.mount(element);
	} else {
		console.error(`Vue component "${componentName}" not found.`);
	}
});